// src/analytics.ts

declare const __RSID__: string;

let sInstance: any
function getS(): any {
    if (!sInstance) {
        // runtime lookup of the Adobe Launch API
        const sgi = (window as any).s_gi
        if (typeof sgi !== 'function') {
            console.warn('Adobe Launch (s_gi) not yet available')
            return null
        }
        sInstance = sgi(__RSID__)
        // ensure first-party cookies
        sInstance.cookieDomain = window.location.hostname
        sInstance.cookieDomainPeriods = 2
    }
    return sInstance
}

function mirrorProps(s: any, props: Record<number, boolean>, eVars: Record<number, any>) {
    for (const k of Object.keys(props).map(Number)) {
        s['prop' + k] = 'D=v' + k
        s['eVar' + k] = eVars[k]
    }
}

// 1) Page-view (once per load)
export function trackPageView(opts: {
    pageName: string
    title: string
    url: string
    lang: string
    domain: string
    fullUrl: string
}) {
    const s = getS()
    if (!s) return
    s.clearVars?.()
    s.pageName = opts.pageName

    const eVars = {
        5: opts.pageName,
        7: opts.pageName.replace(new RegExp('^' + opts.lang + ':'), ''),
        9: opts.title,
        10: opts.url,
        12: opts.lang,
        13: opts.domain,
        30: opts.fullUrl
    }
    mirrorProps(s, { 5: true, 7: true, 9: true, 10: true, 12: true, 13: true, 30: true }, eVars)
    s.t()
}

// 2) Search query
export function trackSearch(prompt: string, opts: {
    pageName: string
    title: string
    url: string
    lang: string
    domain: string
    fullUrl: string
}) {
    const s = getS()
    if (!s) return
    s.clearVars?.()
    s.pageName = opts.pageName
    s.events = 'event5'

    const eVars = {
        2: prompt,
        5: opts.pageName,
        7: opts.pageName.replace(new RegExp('^' + opts.lang + ':'), ''),
        9: opts.title,
        10: opts.url,
        12: opts.lang,
        13: opts.domain,
        30: opts.fullUrl
    }
    mirrorProps(s, { 2: true, 5: true, 7: true, 9: true, 10: true, 12: true, 13: true, 30: true }, eVars)

    s.linkTrackVars = [
        'pageName',
        'events',
        'eVar2', 'eVar5', 'eVar7', 'eVar9', 'eVar10', 'eVar12', 'eVar13', 'eVar30',
        'prop2', 'prop5', 'prop7', 'prop9', 'prop10', 'prop12', 'prop13', 'prop30'
    ].join(',')

    s.linkTrackEvents = 'event5'
    s.tl(true, 'o', 'search')
}

// 3) Link click
export function trackLinkClick(label: string, quickLinkUrl: string, opts: {
    pageName: string
    title: string
    url: string
    lang: string
    domain: string
    fullUrl: string
}) {
    const s = getS()
    if (!s) return
    s.clearVars?.()
    s.pageName = opts.pageName
    s.events = 'event17'

    const eVars = {
        5: opts.pageName,
        7: opts.pageName.replace(new RegExp('^' + opts.lang + ':'), ''),
        9: opts.title,
        10: opts.url,
        12: opts.lang,
        13: opts.domain,
        25: quickLinkUrl,
        30: opts.fullUrl,
        46: label
    }
    mirrorProps(s, { 5: true, 7: true, 9: true, 10: true, 12: true, 13: true, 25: true, 30: true, 46: true }, eVars)

    s.linkTrackVars = [
        'pageName',
        'events',
        'eVar5', 'eVar7', 'eVar9', 'eVar10', 'eVar12', 'eVar13', 'eVar25', 'eVar30', 'eVar46',
        'prop5', 'prop7', 'prop9', 'prop10', 'prop12', 'prop13', 'prop25', 'prop30', 'prop46'
    ].join(',')

    s.linkTrackEvents = 'event17'
    s.tl(true, 'o', 'Regular Link Click')
}

// 4) Download
export function trackDownload(
    label: string,
    quickLinkUrl: string,
    opts: {
        pageName: string
        title: string
        url: string
        lang: string
        domain: string
        fullUrl: string
    }
) {
    const s = getS()
    if (!s) return
    s.clearVars?.()
    s.pageName = opts.pageName
    s.events = 'event17' // same event for link-click

    const eVars: Record<number, any> = {
        5: opts.pageName,
        7: opts.pageName.replace(new RegExp('^' + opts.lang + ':'), ''),
        9: opts.title,
        10: opts.url,
        12: opts.lang,
        13: opts.domain,
        25: quickLinkUrl,
        30: opts.fullUrl,
        46: label
    }

    for (const [key, val] of Object.entries(eVars)) {
        ; (s as any)['eVar' + key] = val
            ; (s as any)['prop' + key] = 'D=v' + key
    }

    // fire download link with type 'd'
    s.tl(true, 'd', 'Download')
}
